'use strict'

import React from 'react';

import Layout from '../Layout.jsx';
import ProjectMenu from '../components/ProjectMenu.jsx';

import {Themes, ActivityView, Links, StatusSummary, KeyInfo} from '../ProjectDetails.jsx';
import Portfolio from '../Portfolio.jsx';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
]);

class IdentifyProgrammeProcessOverview extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).identifyingProgrammeProcess;
    let activities=[ {
        name:"sponsoringTheProgramme",
        link:"/organization",
        status: "notStarted"
      }, {
        name:"confirmProgramMandate",
        link:"/brief",
        status: "notStarted"
      }, {
        name:"appointSROAndProgrammeBoard",
        link: "/organization",
        status: "notStarted"
      }, {
        name: "produceProgrammeBrief",
        link: "/definition?variant=program",
        status: "notStarted"
      }, {
        name: "developProgrammePreparationPlan",
        link: "/plan?show=controls#schedule",
        status: "notStarted"
      }, {
        name: "independentReview",
        link: "?showProgress=identifyProgramme&showMenu=true",
        status: "notStarted"
      }, {
        name: "approvalToProceed",
        link: "?showProgress=identifyProgramme&showMenu=true",
        status: "notStarted"
      }
    ].filter(item=>item!==undefined && !item.disabled);
    return (
      <ActivityView {...this.props} activities={activities} labels={labels}/>
    );
  }
}

class DefiningProgrammeProcessOverview extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).definingProgrammeProcess;
    let activities=[ {
        name:"establishInfrastructure",
        link:"#",
        status: "notStarted"
      }, {
        name:"establishTeam",
        link:"#",
        status: "notStarted"
      }, {
        name:"identifyStakeholders",
        link: "/organization",
        status: "notStarted"
      }, {
        name: "refineVision",
        link: "#",
        status: "notStarted"
      }, {
        name: "developBlueprint",
        link: "#",
        status: "notStarted"
      }, {
        name: "developBenefitProfiles",
        link: "#",
        status: "notStarted"
      }, {
        name: "modelBenefits",
        link: "#",
        status: "notStarted"
      }, {
        name: "validateBenefits",
        link: "#",
        status: "notStarted"
      }, {
        name: "designProjectsDossier",
        link: "#",
        status: "notStarted"
      }, {
        name: "identifyTranches",
        link: "#",
        status: "notStarted"
      }, {
        name: "designProgrammeOrganization",
        link: "#",
        status: "notStarted"
      }, {
        name: "developGovernanceArrangements",
        link: "#",
        status: "notStarted"
      }, {
        name: "developProgrammePlan",
        link: "#",
        status: "notStarted"
      }, {
        name: "confirmBusinessCase",
        link: "#",
        status: "notStarted"
      }, {
        name: "consolidateProgrammeDefinition",
        link: "#",
        status: "notStarted"
      }, {
        name: "prepareFirstTranche",
        link: "#",
        status: "notStarted"
      }, {
        name: "approvalToProceed",
        link: "#",
        status: "notStarted"
      }
    ].filter(item=>item!==undefined && !item.disabled);
    return (
      <ActivityView {...this.props} activities={activities} labels={labels}/>
    );
  }
}

function assignPriority(item) {
  return item.status!=="Closed"
    ? Object.assign({},item,{row:parseInt(item.priority),column:parseInt(item.severity)})
    :  Object.assign({},item,{row:undefined,column:undefined});
}

export class ProgrammeDetails extends React.Component {
  showIdentifyingProgrammeProcessView() {
    return this.props.showProgress==="identifyProgramme";
  }

  showDefiningProgrammeProcessView() {
    return this.props.showProgress==="defineProgramme";
  }

  isProgrammeBriefEnabled() {
    return false;
  }

  isProgrammeDefinitionDocumentEnabled() {
    return false;
  }

  render() {
    let access={
      isBusinessCaseEnabled: ()=>false,//this.isBusinessCaseEnabled.bind(this),
      isQualityEnabled: ()=>false, //this.isQualityEnabled.bind(this),
      isDefinitionEnabled: ()=>true, //this.isDefinitionEnabled.bind(this),
      isProjectBriefEnabled: this.isProgrammeBriefEnabled.bind(this),
      isPIDEnabled : this.isProgrammeDefinitionDocumentEnabled.bind(this)
    };



    var portfolio=this.props.portfolio!==undefined ? this.props.portfolio :
    this.props.programme!==undefined && this.props.programme.portfolio!==undefined && this.props.tenant.portfolios!==undefined ?
    this.props.tenant.portfolios.filter(portfolio=>portfolio.id===this.props.programme.portfolio)[0] : undefined;

    let labels=translations.getTranslation(this.props);


    return (
      <div style={{marginTop: 40, marginLeft:30, fontFamily:"Lato"}}>
        {this.props.programme.isStopped ? <span style={{color:"red", paddingRight:20}}>STOPPED</span> :null}
        {this.props.programme.isPaused ? <span style={{color:"red", paddingRight: 20}}>paused</span> :null}
        <div style={{display:"flex", flexWrap:"wrap", justifyContent:"flex-start"}}>
          <div style={{maxWidth:1016}}>

            <div style={{fontWeight:"bold", fontSize:14 }}>
              {portfolio!==undefined ? portfolio.name : null}
            </div>
            <div style={{fontSize:30, marginBottom:30, width:"100%", fontWeight:"bold", float:"left"}}>
              {this.props.programme.name}
            </div>

            <div style={{display:"inline-block"}}>
              <div style={{padding:0, marginBottom:10, display:"flex", justifyContent: "space-between", flexWrap:"wrap"}}>
                <StatusSummary {...this.props.programme}   {...this.props}/>
                <KeyInfo {...this.props.programme}   {...this.props}/>
              </div>

              {this.showDefiningProgrammeProcessView() ? (
                <DefiningProgrammeProcessOverview {...this.props} project={this.props.programme} access={access}/>
              ) : this.showIdentifyingProgrammeProcessView() ? (
                <IdentifyProgrammeProcessOverview {...this.props} project={this.props.programme} access={access}/>
              ) : (
                <div style={{maxWidth:1016}}>
                  <Themes
                    {...this.props}
                    style="small"
                    project={this.props.programme}
                    access={access}
                  />
                {this.props.projects!==undefined && this.props.projects.length>0 ? (
                  <Portfolio {...this.props} programOverview={true} tenant={this.props.tenant} projectTypes={this.props.tenant.projectTypes} disablePriority={this.props.programme.useTenantPriority===true}/>
                ) : (
                  <div style={{minWidth: 1016}}>
                  </div>
                ) }
                </div>
              )}
            </div>
          </div>

          <div style={{marginLeft:"auto"}}>
            <Links
              {...this.props}
              {...this.props.programme}
              standardLinks={this.props.tenant.standardLinks}
              mode={this.props.linkMode}
              edit={this.props.edit}
              add={this.props.add}
              briefEnabled={this.isProgrammeBriefEnabled()}
              pidEnabled={this.isProgrammeDefinitionDocumentEnabled()}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default class ProgrammeDetailsPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true)
      ? <ProjectMenu
          {...this.props}
          project={this.props.programme}
        />
      : undefined;
    return (
      <Layout {...this.props} project={this.props.programme} projectMenu={menu}>
        <ProgrammeDetails {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/programme/ProgrammeDetails.jsx